import { render, staticRenderFns } from "./BlipArtistCategoryDetail.vue?vue&type=template&id=a72997a6&scoped=true&"
import script from "./BlipArtistCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./BlipArtistCategoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlipArtistCategoryDetail.vue?vue&type=style&index=0&id=a72997a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72997a6",
  null
  
)

export default component.exports